import { Check, X } from "lucide-react";
import { Container, Section, Eyebrow, Reveal } from "@/components/kit";

const rows = [
  { label: "Charges for qualified meetings only", us: true, them: false },
  { label: "No-shows are never billed", us: true, them: false },
  { label: "Deep ICP research before outreach", us: true, them: false },
  { label: "Transparent, parameter-based qualification", us: true, them: false },
  { label: "Owns deliverability & sending infrastructure", us: true, them: false },
  { label: "Bills flat retainers regardless of results", us: false, them: true },
  { label: "Counts raw bookings as 'success'", us: false, them: true },
  { label: "Blasts generic templates at scale", us: false, them: true },
];

const Cell = ({ ok }) =>
  ok ? (
    <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-gold/15 text-gold">
      <Check className="h-4 w-4" strokeWidth={3} />
    </span>
  ) : (
    <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-white/5 text-white/30">
      <X className="h-4 w-4" strokeWidth={3} />
    </span>
  );

export const Comparison = () => (
  <Section data-testid="comparison-matrix">
    <Container>
      <div className="max-w-3xl">
        <Eyebrow>Why We're Different</Eyebrow>
        <h2 className="mt-6 font-display text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight text-white">
          ICP Matters vs. the generic agency
        </h2>
        <p className="mt-6 text-white/60 text-base md:text-lg leading-relaxed">
          Most agencies sell activity. We sell outcomes. Here's the difference laid bare.
        </p>
      </div>

      <Reveal className="mt-12 overflow-hidden rounded-2xl border border-white/10">
        <div className="grid grid-cols-[1.5fr_0.75fr_0.75fr] bg-navy-800/60">
          <div className="p-5 md:p-6 font-mono-jb text-xs uppercase tracking-widest text-white/40">
            Capability
          </div>
          <div className="p-5 md:p-6 text-center border-l border-white/10 bg-gold/10">
            <span className="font-display text-base md:text-lg font-semibold text-gold">
              ICP Matters
            </span>
          </div>
          <div className="p-5 md:p-6 text-center border-l border-white/10">
            <span className="font-display text-base md:text-lg font-semibold text-white/45">
              Generic Agency
            </span>
          </div>
        </div>

        {rows.map((r, i) => (
          <div
            key={r.label}
            className={`grid grid-cols-[1.5fr_0.75fr_0.75fr] items-center border-t border-white/10 ${
              i % 2 === 0 ? "bg-navy-900" : "bg-navy-800/30"
            }`}
          >
            <div className="p-5 md:p-6 text-sm md:text-base text-white/75">{r.label}</div>
            <div className="p-5 md:p-6 flex justify-center border-l border-white/10 bg-gold/[0.06]">
              <Cell ok={r.us} />
            </div>
            <div className="p-5 md:p-6 flex justify-center border-l border-white/10">
              <Cell ok={r.them} />
            </div>
          </div>
        ))}
      </Reveal>
    </Container>
  </Section>
);
